import { useState, useRef } from "react";
import { FiMenu } from "react-icons/fi";
import Logo from "../../elements/logo/Logo";
import Nav from './Nav';
import MobileMenu from './MobileMenu';
import Darkmode from "./Darkmode";
import useStickyHeader from "./useStickyHeader";

const HeaderOne = ({ HeaderSTyle }) => {
    const [ofcanvasShow, setOffcanvasShow] = useState(false);
    const companyName = 'KR Power Supports Pvt Ltd';

    const onCanvasHandler = () => {
        setOffcanvasShow(prev => !prev);
    }
    const ref = useRef();
    const sticky = useStickyHeader(50);
    const headerClasses = `header-default ${sticky ? 'sticky' : ''}`;

    return (
        <>
            <header ref={ref} className={`rn-header header-default ${HeaderSTyle} ${headerClasses}`}>
                <div className="container position-relative">
                    <div className="row align-items-center row--0">
                        <div className="col-lg-3 col-md-6 col-10 col-sm-10" >
                            <div className="logo-with-title">
                                <Logo
                                    image={`kr-logo.png`}
                                    image2={`kr-logo.png`}
                                />
                                <h2 className="logo-title">{companyName}</h2>
                            </div>
                        </div>
                        <div className="col-lg-9 col-md-6 col-2 col-sm-2 position-static">
                            <div className="header-right">
                                <nav className="mainmenu-nav d-none d-lg-block">
                                    <Nav />
                                </nav>
                                <Darkmode />
                                <div className="mobile-menu-bar ml--5 d-block d-lg-none">
                                    <div className="hamberger">
                                        <span className="hamberger-button" onClick={onCanvasHandler}><FiMenu /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <MobileMenu show={ofcanvasShow} onClose={onCanvasHandler} />
        </>
    )
}
export default HeaderOne;
